import { RebaseTranslations } from "@rebasepro/cms-types";

export const it: RebaseTranslations = {
    // ─── Form actions ────────────────────────────────────────────
    save: "Salva",
    create: "Crea",
    create_copy: "Crea copia",
    save_and_close: "Salva e chiudi",
    create_copy_and_close: "Crea copia e chiudi",
    create_and_close: "Crea e chiudi",
    discard: "Scarta",
    clear: "Cancella",
    cancel: "Annulla",

    // ─── Entity actions ──────────────────────────────────────────
    edit: "Modifica",
    copy: "Copia",
    delete: "Elimina",
    delete_not_allowed: "Hai selezionato almeno un'entità che non puoi eliminare",
    edit_entity: "Modifica",
    back_to_detail: "Torna ai dettagli",

    // ─── Delete dialog ───────────────────────────────────────────
    delete_confirmation_title: "Eliminare?",
    delete_confirmation_body: "Questo eliminerà l'entità. Sei sicuro?",
    delete_multiple_confirmation_body: "Questo eliminerà le entità selezionate. Sei sicuro?",

    // ─── Unsaved-changes dialog ───────────────────────────────────
    unsaved_changes_title: "Modifiche non salvate",
    unsaved_changes_body: "Hai modifiche non salvate. Vuoi scartarle?",
    discard_changes: "Scarta le modifiche",
    keep_editing: "Continua a modificare",
    clear_form: "Svuotare il modulo?",
    discard_changes_confirmation: "Tutte le modifiche non salvate andranno perse. Questa azione non può essere annullata.",
    clear_form_confirmation: "Tutti i valori inseriti verranno cancellati. Questa azione non può essere annullata.",

    // ─── Collection table / toolbar ──────────────────────────────
    search: "Cerca",
    find_by_id: "Cerca per ID",
    find_entity_by_id: "Cerca entità per ID",
    filter: "Filtra",
    filters: "Filtri",
    records_in_view: "Record in questa vista",
    clear_filter: "Cancella filtro",
    clear_filter_sort: "Cancella filtro/ordinamento",
    clear_sort: "Cancella ordinamento",
    sort: "Ordina",
    sort_by: "Ordina per",
    sort_then_by: "Poi per",
    sort_ascending: "Ordina in modo crescente",
    sort_descending: "Ordina in modo decrescente",
    sort_remove: "Rimuovi ordinamento",
    sort_move_up: "Rendi questa chiave più importante",
    sort_move_down: "Rendi questa chiave meno importante",
    sort_remove_key: "Rimuovi questa chiave di ordinamento",
    sort_key_position: "Chiave di ordinamento {{position}}",
    sort_shift_click_hint: "Maiusc+clic per aggiungere una colonna sotto l'ordinamento attuale",
    save_entity_before_subcollections: "Devi salvare l'entità prima di aggiungere altre raccolte",
    clear_all: "Cancella tutto",
    no_items: "Nessun elemento",
    no_entries_found: "Nessuna voce trovata",
    all_entries_loaded: "Tutte le {{count}} voci caricate",
    create_your_first_entry: "Crea la tua prima voce",
    no_results_filter_sort: "Nessun risultato con il filtro/ordinamento applicato",
    no_results_search: "Nessun risultato trovato per \"{{search}}\"",
    add: "Aggiungi",
    remove: "Rimuovi",
    multiple_entities: "Entità multiple",
    unsaved_changes: "Hai modifiche non salvate in {{collectionName}}.",
    so_empty: "Così vuoto...",
    no_results: "Nessun risultato con il filtro/ordinamento applicato",
    refresh_data: "Aggiorna i dati",
    dark_mode: "Scuro",
    light_mode: "Chiaro",
    system_mode: "Sistema",
    join_newsletter: "Iscriviti alla newsletter, niente spam",
    ok: "Ok",
    save_collection_config: "Salva struttura della collezione",
    search_for_more_icons: "Cerca altre icone…",
    ai_modified: "Modificato dall'IA",
    size_label: "Dimensioni",
    group_by: "Raggruppa per",
    initialize_kanban_order: "Inizializza ordine Kanban",
    copy_id: "Copia ID",
    add_specific: "Aggiungi {{name}}",
    add_named: "Aggiungi \"{{name}}\"",
    select_specific: "Seleziona {{name}}",
    select_from: "Seleziona da {{name}}",
    done: "Fatto",
    log_out: "Esci",
    column_cannot_be_edited: "Questa colonna non può essere modificata direttamente",
    close: "Chiudi",
    hide_list: "Nascondi elenco",
    show_list: "Mostra elenco",
    unsaved_local_changes: "Modifiche locali non salvate",
    unsaved_local_changes_description: "Questo documento è stato modificato localmente e ha modifiche non salvate. Queste modifiche locali andranno perse se non le applichi.",
    preview_changes: "Anteprima modifiche",
    apply_changes: "Applica modifiche",
    discard_local_changes: "Scarta modifiche locali",
    preview_local_changes: "Anteprima modifiche locali",
    preview_local_changes_description: "Queste sono le modifiche locali che verranno applicate al modulo.",
    type: "Tipo",
    string: "stringa",
    number: "numero",
    boolean: "booleano",
    date: "data",
    map: "mappa",
    array: "array",
    arrays_of_arrays_not_supported: "Array di array non sono supportati.",
    data_type_not_supported: "Tipo di dati {{dataType}} non ancora supportato",
    passkey_error_unsupported: "Il tuo dispositivo o browser non supporta le passkey.",

    // ─── Entity form feedback ─────────────────────────────────────
    saved_correctly: "Salvato correttamente",
    error_before_saving: "Errore nella preparazione dei dati",
    error_after_saving: "Errore nel processo post-salvataggio",
    error_saving_entity: "Errore durante il salvataggio dell'entità",
    entity_does_not_exist: "Questa entità non esiste nel database",
    form_modified: "Questo modulo è stato modificato",
    form_in_sync: "Il modulo attuale è sincronizzato con il database",
    fix_errors_before_saving: "Correggi gli errori evidenziati prima di salvare",

    admin: "Admin",
    home: "Home",
    this_form_has_errors: "Questo modulo contiene errori",
    error_loading_navigation: "Errore durante il caricamento della navigazione",
    error_loading_auth: "Errore durante il caricamento dell'autenticazione",
    this_form_has_been_modified: "Questo modulo è stato modificato",
    current_form_in_sync: "Il modulo corrente è sincronizzato con il database",
    open_in_console: "Apri nella console",
    collection_does_not_exist: "La collezione specificata non esiste. Controlla la console",
    unexpected_value: "Valore inaspettato",
    unexpected_value_click_to_edit: "Valore inaspettato. Fai clic per modificare",
    unexpected_reference_value: "Valore di riferimento inaspettato. Fai clic per modificare",
    copy_url_to_clipboard: "Copia url negli appunti",
    open_image_in_new_tab: "Apri immagine in una nuova scheda",
    reference_not_set: "Riferimento non impostato",
    reference_does_not_exist: "Il riferimento non esiste",
    entity_not_found: "Entità non trovata",
    entity_not_found_body: "Questo record non esiste, oppure è nascosto per te dalla sicurezza a livello di riga.",
    back_to_collection: "Torna a {{name}}",
    file_not_found: "File non trovato",
    unsaved_changes_in_entity: "Hai modifiche non salvate in questa entità.",
    delete_this_role: "Elimina questo ruolo",
    no_roles_yet: "Non hai ancora ruoli.",
    create_default_roles: "Crea ruoli predefiniti",
    delete_role_confirmation: "Sei sicuro di voler eliminare questo ruolo?",
    delete_this_user: "Elimina questo utente",
    no_users_yet: "Non ci sono ancora utenti",
    add_logged_user_as_admin: "Aggiungi l'utente registrato come amministratore",
    add_current_user_as_admin: "Aggiungi l'utente corrente come amministratore",
    create_default_roles_and_add_admin: "Crea i ruoli predefiniti e aggiungi l'utente corrente come amministratore",
    delete_user_confirmation: "Sei sicuro di voler eliminare questo utente?",
    create_your_users_and_roles: "Crea i tuoi utenti e ruoli",
    no_users_or_roles_defined: "Non hai definito né utenti né ruoli. Puoi creare ruoli predefiniti e aggiungere l'utente corrente come amministratore.",
    save_before_changing_schema: "Devi salvare il documento prima di modificare lo schema",
    edit_schema_for_this_form: "Modifica lo schema per questo modulo",
    no_permissions_to_edit_collection: "Non hai i permessi per modificare questa collezione",
    browser_does_not_support_audio: "Il tuo browser non supporta l'elemento audio.",
    user_not_found: "Utente non trovato: {{value}}",

    // ─── Collection view actions ──────────────────────────────────
    delete_selected: "Elimina selezionato",
    cannot_delete_selected: "Hai selezionato almeno un'entità che non puoi eliminare",

    // ─── Array / field containers ─────────────────────────────────
    add_entry: "Aggiungi",
    add_on_top: "Aggiungi in alto",
    add_below: "Aggiungi in basso",
    add_to_field: "Aggiungi a {{fieldName}}",
    value: "Valore",
    key: "Chiave",
    drag_drop_multiple: "Trascina qui alcuni file oppure fai clic per selezionarli. Trascina per riordinare.",
    drag_drop_single: "Trascina qui un file oppure fai clic per selezionarne uno",

    // ─── Navigation / scaffold ────────────────────────────────────
    open_menu: "Apri menù",
    close_drawer: "Chiudi cassetto",
    navigation_drawer: "Cassetto di navigazione",
    collapse: "Comprimi",
    expand: "Espandi",
    change_language: "Cambia lingua",
    toggle_theme: "Cambia tema",
    user_menu: "Menu utente",

    // ─── Error states ─────────────────────────────────────────────
    error: "Errore",
    error_loading_data: "Impossibile caricare i dati",
    error_check_server_logs: "Consulta i log del server per i dettagli.",
    error_technical_details: "Dettagli tecnici",
    error_uploading_file: "Errore durante il caricamento del file",
    error_deleting: "Errore durante l'eliminazione",
    error_before_delete: "Errore prima dell'eliminazione",
    error_updating_asset: "Errore durante l'aggiornamento dell'asset",
    error_deleting_asset: "Errore durante l'eliminazione dell'asset",
    error_firestore_index: "Per questa query è richiesto un indice Firestore.",
    create_index: "Crea indice",
    value_is_not_reference: "Il valore non è un riferimento.",
    click_to_edit: "Fai clic per modificare",
    data_is_not_array_of_references: "I dati non sono un array di riferimenti",

    // ─── Misc ─────────────────────────────────────────────────────
    loading: "Caricamento in corso",
    local_changes_applied: "Modifiche locali applicate al modulo",
    local_changes_discarded: "Modifiche locali scartate",
    are_you_sure_leave: "Sei sicuro di voler uscire da questa pagina?",
    see_console_details: "Vedi la console per maggiori dettagli.",
    drop_here_create_group: "Rilascia qui per creare un nuovo gruppo",
    filter_for_null_values: "Filtra per valori nulli",
    value_updated_elsewhere: "Questo valore è stato aggiornato altrove",
    add_property: "Aggiungi proprietà",
    edit_name: "Modifica {{name}}",
    this_entity_not_exist: "Questa entità non esiste nel database",
    internal_error: "ERRORE interno",

    // ─── Rename group dialog ──────────────────────────────────────
    rename_group: "Rinomina gruppo",
    group_name_label: "Nome gruppo",
    group_name_empty_error: "Il nome del gruppo non può essere vuoto.",
    group_name_exists_error: "Questo nome del gruppo esiste già.",

    // ─── Search ───────────────────────────────────────────────────
    search_collections: "Cerca collezioni",

    // ─── Navigation groups ────────────────────────────────────────
    views_group: "Viste",

    // ─── Entity Edit View ─────────────────────────────────────────
    youd_need_to_save_before_additional_collections: "Devi salvare la tua entità prima di poter aggiungere altre collezioni",

    // ─── Not Found Page ───────────────────────────────────────────
    page_not_found: "Pagina non trovata",
    page_not_found_body: "Questa pagina non esiste o potresti non avere i permessi per accedervi",
    back_to_home: "Torna alla home",

    // ─── Collection Editor ─────────────────────────────────────────
    default_collection_view: "Vista collezione predefinita",
    table_view: "Tabella",
    cards_view: "Schede (card)",
    kanban_view: "Kanban",
    choose_how_entities_displayed_default: "Scegli come debbano essere visualizzate le entità di default",

    document_view: "Vista documento",
    side_panel: "Pannello laterale",
    full_screen: "Schermo intero",
    should_documents_opened_full_screen: "I documenti dovrebbero essere aperti a schermo intero o in una finestra di dialogo laterale integrata",

    select_custom_view: "Seleziona vista personalizzata",
    no_custom_views_defined: "Nessuna vista personalizzata definita. Definisci le viste personalizzate nelle impostazioni di personalizzazione prima di utilizzare questa finestra.",

    select_custom_action: "Seleziona azione personalizzata",
    no_custom_actions_defined: "Nessuna azione personalizzata definita. Definisci le azioni personalizzate nelle impostazioni di personalizzazione prima di utilizzare questa finestra.",

    no_collections_found: "Nessuna collezione trovata",
    start_building_collections: "Inizia facilmente a costruire collezioni in Rebase. Mapale comodamente ai dati del tuo database esistente, importali da file o usa i nostri modelli.",
    create_first_collection: "Crea la tua prima collezione",
    define_collections_programmatically: "Puoi anche definire le collezioni a livello di codice.",
    edit_collection: "Modifica collezione",
    no_permissions_edit_collection: "Non disponi dei permessi per modificare questa collezione",
    no_permissions_create_collection: "Non disponi dei permessi per creare collezioni",
    create_collection: "Crea collezione",
    update_collection: "Aggiorna collezione",

    new_collection: "Nuova collezione",
    add_new_collection: "Aggiungi nuova collezione",
    collection_with_name: "Collezione {{name}}",
    change_icon: "Cambia icona",
    is_subcollection_of: "Questa è una sottocollezione di",
    name: "Nome",
    collection_name_description: "Il nome di questa collezione, solitamente un nome al plurale (es. Prodotti)",
    path: "Percorso",
    relative_path_to_parent: "Percorso relativo al genitore (non è necessario includere il percorso genitore)",
    path_in_database: "Il percorso in cui questa collezione è archiviata nel database",
    singular_name: "Nome singolare",
    singular_name_description: "Facoltativamente definisci un nome singolare per le tue entità",
    description: "Descrizione",
    description_of_collection: "Descrizione della collezione, puoi utilizzare il markdown",
    collection_id: "ID della collezione",
    collection_id_description: "Questo ID identifica in modo univoco questa collezione. Spesso coincide con il percorso.",
    collection_group: "Gruppo di collezioni",
    collection_group_description: "Un gruppo di collezioni include tutte le collezioni con lo stesso percorso. Ciò consente di interrogare più collezioni simultaneamente.",
    advanced_settings: "Impostazioni avanzate",
    doc_history_global: "Revisioni della cronologia dei documenti abilitate se abilitate a livello globale",
    doc_history_enabled: "Revisioni della cronologia dei documenti ABILITATE",
    doc_history_not_enabled: "Revisioni della cronologia dei documenti NON abilitate",
    doc_history_description: "Se abilitata questa opzione, ogni documento in questa collezione avrà una cronologia delle modifiche per scopi di auditing. I dati vengono salvati in una sottocollezione del documento denominata __history.",
    document_id_generation: "Generazione ID documento",
    code_defined: "Definito dal codice",
    users_must_define_id: "Gli utenti devono definire un ID",
    users_can_define_id: "Gli utenti possono definire un ID, ma non è obbligatorio",
    doc_id_auto_generated: "L'ID del documento viene generato automaticamente",
    config_doc_id_generation: "Configura il modo in cui vengono generati gli ID dei documenti per le nuove entità.",
    enable_text_search: "Abilita la ricerca testuale in questa collezione",
    text_search_description: "Attiva la ricerca testuale per questa collezione. Se non è specificato un delegato di ricerca testuale, si utilizzerà la ricerca locale integrata. Si sconsiglia l'uso con collezioni grandi, essendo soggetto a problemi di prestazioni e costi.",
    database_id: "ID del Database",
    default_text: "(predefinito)",

    custom_actions: "Azioni personalizzate",
    more_info: "Ulteriori info",
    define_custom_actions_cli: "Definisci le tue azioni personalizzate ed eseguine l'upload tramite l'interfaccia a riga di comando (CLI).",
    action_defined_in_code: "Questa azione è definita dal codice con la chiave",
    add_custom_entity_action: "Aggiungi azione di entità personalizzata",
    remove_this_action: "Rimuovi questa azione?",
    remove_action_warning: "Questa operazione non eliminerà dati, ma solo l'azione dal pannello di amministrazione",

    subcollections_of: "Sottocollezioni di",
    add_subcollection: "Aggiungi sottocollezione",
    custom_views: "Viste personalizzate",
    define_custom_views_cli: "Definisci le tue viste personalizzate e caricale tramite l'interfaccia a riga di comando (CLI).",
    view_defined_in_code: "Questa vista è definita nel codice dalla chiave",
    add_custom_entity_view: "Aggiungi vista ad entità personalizzata",
    delete_this_subcollection: "Vuoi eliminare questa sottocollezione?",
    remove_collection_warning: "Attenzione: questo rimuoverà solo la collezione configurata nel pannello di amministrazione, senza eliminare i dati effettivi.",
    remove_this_view: "Desideri rimuovere questa vista?",
    remove_view_warning: "Questa azione rimuoverà solo la visualizzazione dal pannello di amministrazione; i dati rimarranno intatti.",

    no_collection_selected: "Nessuna collezione selezionata",
    code_for_collection: "Codice per",
    use_config_define_json: "Utilizza questa configurazione per definire la collezione in formato JSON.",
    customise_collection_code: "Se desideri personalizzare ulteriormente tramite codice la collezione, puoi aggiungere questo frammento di codice nel tuo pannello di amministrazione.",
    copied: "Copiato",

    property_cant_be_edited: "Non è possibile modificare questa proprietà",
    property_not_editable_description: "Potresti non disporre dei permessi per modificarla o potrebbe essere definita nel codice e non modificabile.",
    delete_this_property: "Desideri eliminare questa proprietà?",
    delete_property_warning: "Questo non cancellerà i dati associati, modificherà semplicemente la configurazione della collezione.",
    error_must_specify_id: "È d'obbligo specificare un id per questo campo",
    error_id_format: "L'id può contenere solo lettere, numeri e underscore (_) e non deve iniziare con un numero",
    error_id_already_exists: "Esiste già un altro campo utilizzando questo ID",
    error_must_specify_title: "Specifica un titolo obbligatorio per questo campo",
    custom_or_other: "Personalizzato/Altro",
    select_property_widget: "Scegli un widget per la proprietà",
    error_changing_data_type: "Il widget selezionato adotta un formato di dati diverso rispetto a quello iniziale. Questa modifica potrebbe causare errori sui dati già presenti.",
    required: "Richiesto",

    enum_form_dialog: "Finestra di dialogo modulo Enum",
    imported_data_preview: "Anteprima dei dati importati",
    entities_with_same_id_overwritten: "Le entità con lo stesso id verranno sovrascritte",
    collection_editor: "Editor della collezione",
    properties_in_this_group: "Proprietà di questo gruppo",
    data_property_mapping: "Mappatura dei dati alle proprietà",
    property_edit_view: "Vista di modifica delle proprietà",
    all_of_these: "Tutti questi",
    any_of_these: "Alcuni di questi",

    only_admins_edit_roles: "Solo gli amministratori possono modificare i ruoli",
    error_user_not_found: "Utente non trovato",
    all_roles: "Tutti i ruoli",
    role: "Ruolo",
    name_of_this_role: "Nome di questo ruolo",
    id_of_this_role: "ID di questo ruolo",
    create_entities: "Crea entità",
    read_entities: "Leggi entità",
    update_entities: "Aggiorna entità",
    delete_entities: "Elimina entità",
    all_collections: "Tutte le collezioni",
    create_entities_in_collections: "Crea entità nelle collezioni",
    access_all_data_in_every_collection: "Accedi a tutti i dati in ogni collezione",
    update_data_in_any_collection: "Aggiorna i dati in qualsiasi collezione",
    delete_data_in_any_collection: "Elimina i dati in qualsiasi collezione",
    allow_all_permissions_in_this_collections: "Consenti tutti i permessi in queste collezioni",
    all: "Tutto",
    customise_permissions_description: "Puoi personalizzare i permessi che gli utenti associati a questo ruolo possono eseguire nelle entità di ciascuna collezione",
    create_collections: "Crea collezioni",
    yes: "Sì",
    no: "No",
    can_user_create_collections: "L'utente può creare collezioni",
    edit_collections: "Modifica collezioni",
    only_own_collections: "Solo le proprie collezioni",
    own: "Propri",
    can_user_edit_collections: "L'utente può modificare le collezioni",
    delete_collections: "Elimina collezioni",
    can_user_delete_collections: "L'utente può eliminare le collezioni",
    error_saving_role: "Si è verificato un errore durante il salvataggio del ruolo",
    create_role: "Crea ruolo",
    update: "Aggiorna",

    only_admins_change_roles: "Solo gli amministratori possono modificare i ruoli",
    must_be_at_least_one_admin: "Deve esserci almeno un amministratore",
    logged_user_not_found: "Utente connesso non trovato",
    user: "Utente",
    user_id: "ID utente",
    name_of_this_user: "Nome dell'utente",
    email_of_this_user: "Email dell'utente",
    roles: "Ruoli",
    create_user: "Crea utente",

    users: "Utenti",
    add_user: "Aggiungi utente",
    add_role: "Aggiungi ruolo",
    is_admin: "È amministratore",
    default_permissions: "Permessi predefiniti",
    created_on: "Creato il",
    email: "Email",
    id: "ID",
    read: "Lettura",

    column_in_file: "Colonna nel file",
    map_to_property: "Mappa alla proprietà",
    default_values: "Valori predefiniti",
    default_values_description: "Non tutte le righe del file importato contengono dati per ogni colonna. Assegna valori predefiniti che Rebase utilizzerà per le colonne mancanti.",
    property: "Proprietà",
    default_value: "Valore predefinito",
    autogenerate_id: "Genera automaticamente ID",
    id_column_description: "Imposta la colonna che verrà utilizzata come ID dell'entità",
    do_not_set_value: "Non impostare il valore",
    set_value_to_true: "Imposta il valore su Vero",
    set_value_to_false: "Imposta il valore su Falso",
    drag_and_drop_file: "Trascina e rilascia un file CSV, Excel o JSON qui, oppure fai clic per caricare",
    error_saving_data: "Errore durante il salvataggio dei dati",
    retry: "Riprova",
    saving_data: "Salvataggio dei dati in corso...",
    entities_saved: "entità salvate",
    do_not_close_tab: "Non chiudere questa scheda durante l'importazione dei dati",
    import: "Importa",
    import_data: "Importa dati",
    upload_file_description: "Carica il tuo file CSV, Excel o foglio di calcolo per importare i dati",
    back: "Indietro",
    next: "Avanti",
    save_data: "Salva dati",
    use_column_as_id: "Usa questa colonna come ID dell'entità",
    do_not_import_property: "Non importare questa proprietà",
    entities_will_be_overwritten: "Le entità esistenti con lo stesso ID verranno sovrascritte",
    data_imported_successfully: "Dati importati con successo",
    export: "Esporta",
    export_data: "Esporta dati",
    download_table_csv: "Scarica la tabella come file CSV",
    csv: "CSV",
    json: "JSON",
    dates_as_timestamps: "Date come timestamp",
    dates_as_strings: "Date come stringhe",
    flatten_arrays: "Appiattisci gli array",
    download: "Scarica",
    large_number_of_documents: "Questa collezione contiene un numero elevato di documenti ({{count}})",
    too_many_documents_to_export: "Questa collezione contiene più documenti ({{count}}) di quanti il browser possa esportarne in un solo file (limite {{limit}}). Filtrala prima di esportare.",
    include_undefined_values: "Includi valori non definiti",
    submit: "Invia",

    no_filterable_properties: "Nessuna proprietà filtrabile disponibile",
    apply_filters: "Applica filtri",

    // ─── Filter Presets ──────────────────────────────────────────
    filter_presets: "Preimpostazioni",
    filter_preset_apply: "Applica preimpostazione",
    filter_preset_active: "Attivo: {{label}}",

    list: "Elenco",
    table_view_mode: "Tabella",
    cards: "Schede",
    board: "Bacheca",
    initialize_kanban_order_desc: "Verranno assegnati valori di ordine sequenziali a tutti gli elementi che ne sono privi. Gli elementi manterranno l'ordine corrente all'interno di ciascuna colonna.",
    kanban_view_not_available: "Vista Kanban non disponibile",
    kanban_view_requires_enum: "La vista Kanban richiede una proprietà stringa con valori enumerati per raggruppare le entità nelle colonne. Aggiungi una proprietà enum allo schema della tua collezione per utilizzare questa vista.",
    no_enum_values_configured: "Nessun valore enumerativo configurato per \"{{property}}\"",
    items_need_backfill: "Alcuni elementi non hanno un ordine definito. Fai clic su 'Inizializza' per impostare l'ordine.",
    kanban_order_not_configured: "L'ordinamento drag-and-drop non è configurato. Imposta una proprietà di ordinamento nelle impostazioni della collezione per mantenere le posizioni delle schede.",
    initialize: "Inizializza",
    confirm_multiple_delete: "Conferma eliminazione multipla",
    delete_entity_confirm_title: "Eliminare '{{entityName}}'?",
    add_existing: "Aggiungi esistente",
    unlink_entity_confirm_title: "Rimuovere questo/a {{entityName}} da questo record?",
    unlink_entity_confirm_body: "Resta in {{collectionName}} e disponibile per altri record.",
    confirm_multiple_unlink: "rimuoverli da questo record?",
    no_filter: "Nessun filtro",
    is_true: "è vero",
    is_false: "è falso",
    error_uploading_file_size: "Errore nel caricamento: il file supera {{maxSize}} byte",
    error_uploading_file_type: "Errore nel caricamento: tipo di file non supportato",
    drag_drop_files: "Trascina qui i file, oppure clicca per modificarli",
    drag_drop_file: "Trascina qui un file, oppure clicca per modificarlo",
    multiple_deleted: "Eliminazioni multiple",
    some_entities_deleted: "Alcune entità sono state eliminate, ma non tutte",
    error_deleting_entities: "Errore durante l'eliminazione delle entità",
    deleted: "eliminata",
    selection_options: "Opzioni di selezione",
    selection_menu_all_loaded: "Tutto in questa pagina",
    selection_menu_all_matching: "Tutti i {{total}} {{collection}}",
    selection_menu_none: "Nessuno",
    selection_select_all_loaded: "Seleziona le righe caricate",
    selection_deselect_all: "Deseleziona tutto",
    selection_reading_rows: "Lettura delle righe… {{loaded}} di {{total}}",
    selection_reading_rows_unknown: "Lettura delle righe… {{loaded}} finora",
    selection_deleting_progress: "Eliminati {{completed}} di {{total}}",
    confirm_delete_selection: "Eliminare {{total}} {{collection}}?",
    confirm_delete_selection_unknown: "Eliminare tutte le righe che corrispondono al filtro attuale?",
    confirm_delete_selection_body: "L’operazione non può essere annullata. Ogni riga viene eliminata singolarmente, quindi potrebbe richiedere del tempo.",

    export_selection_count: "Scarica le {{total}} righe selezionate in formato {{format}}",
    export_selection_all_matching: "Scarica tutti i {{collection}} che corrispondono al filtro attuale",

    select_reference: "Seleziona riferimento",
    select_references: "Seleziona riferimenti",
    account_settings: "Impostazioni account",
    profile: "Profile",
    security: "Sicurezza",
    sessions: "Sessions",
    change_password: "Cambia password",
    current_password: "Password attuale",
    new_password: "Nuova password",
    confirm_password: "Conferma la nuova password",
    password_changed: "Password modificata con successo. Verrai disconnesso.",
    passwords_dont_match: "Le password non coincidono",
    password_too_short: "La password deve contenere almeno 8 caratteri",
    password_change_not_available: "La modifica della password non è disponibile per gli account che usano provider di accesso esterni.",
    changing_password: "Modifica in corso...",
    display_name: "Nome visualizzato",
    photo_url: "URL della foto",
    save_profile: "Salva profilo",
    saving: "Saving...",
    no_active_sessions: "Nessuna sessione attiva trovata.",
    revoking: "Revoking...",
    revoke_all_sessions: "Revoca tutte le sessioni",
    unknown_device: "Dispositivo sconosciuto",
    current: "Current",
    role_id: "ID del ruolo",
    role_name: "Nome del ruolo",
    add_reference: "Aggiungi riferimento",
    add_reference_to: "Aggiungi riferimento a {{name}}",

    /** RolesView — table & permissions */
    role_deleted_successfully: "Ruolo eliminato con successo",
    error_deleting_role: "Errore durante l'eliminazione del ruolo",
    collection_permissions: "Permessi della collezione",
    collection: "Collection",
    no_collections_configured: "Nessuna collezione configurata",
    no_security_rules_defined: "Nessuna regola di sicurezza definita: tutte le operazioni sono senza restrizioni",
    no_rules: "nessuna regola",

    /** UsersView — snackbar */
    bootstrap_admin_success: "Ora sei amministratore! Aggiornamento in corso...",
    failed_to_bootstrap_admin: "Impossibile creare l'amministratore iniziale",
    user_deleted_successfully: "Utente eliminato con successo",
    error_deleting_user: "Errore durante l'eliminazione dell'utente",
    user_created_successfully: "Utente creato con successo",
    invitation_sent: "È stata inviata un'email di invito a {{email}}. Il link consente di impostare la password.",
    invitation_sent_title: "Invito inviato",
    temporary_password: "Password temporanea",
    temporary_password_description: "L'email non è configurata. Condividi questa password temporanea con l'utente in modo sicuro. Non verrà mostrata di nuovo.",
    temporary_password_email_failed_description: "Non è stato possibile consegnare l'email. Condividi questa password temporanea con l'utente in modo sicuro. Non verrà mostrata di nuovo.",
    copy_password: "Copia password",
    password_copied: "Password copiata negli appunti",

    /** UsersView — pagination & search */
    search_users: "Cerca utenti",
    created: "Creato",
    actions: "Azioni",
    no_users_found: "Nessun utente trovato",
    reset_password: "Reimposta password",
    reset_password_success: "Password reimpostata con successo",
    reset_password_confirmation: "Vuoi davvero reimpostare la password di questo utente?",
    reset_password_send_email: "Invia un'email di reimpostazione della password",
    reset_password_set_manually: "Imposta una password manualmente",
    reset_password_set_manually_description: "La password viene aggiornata subito e non viene inviata alcuna email. Condividila con l'utente in modo sicuro.",

    /** Permission-denied empty states */
    no_permission_to_view_users: "Non hai i permessi per visualizzare gli utenti",
    no_permission_to_view_roles: "Non hai i permessi per visualizzare i ruoli",
    no_permission_description: "Contatta un amministratore se hai bisogno di accedere a questa sezione.",
    error_resetting_password: "Errore durante la reimpostazione della password",

    /** Editor table-bubble */
    add_row_before: "Inserisci riga prima",
    add_row_after: "Inserisci riga dopo",
    delete_row: "Elimina riga",
    add_column_before: "Inserisci colonna prima",
    add_column_after: "Inserisci colonna dopo",
    delete_column: "Elimina colonna",
    delete_table: "Elimina tabella",

    /** Editor image-bubble */
    alt_text: "Testo alternativo",
    title: "Title",

    /** MapFieldBinding */
    a_property_of_this_map_has_error: "Una proprietà di questa mappa contiene un errore",

    /** AI Collection Generator Popover */
    generate_collection_with_ai: "Genera collezione con AI",
    modify_collection_with_ai: "Modifica collezione con AI",
    describe_collection_to_create: "Descrivi la collezione che vuoi creare.",
    describe_changes_to_make: "Descrivi le modifiche che vuoi apportare a questa collezione.",
    ai_placeholder_create: "es. Crea una collezione di prodotti con nome, prezzo, descrizione e categoria...",
    ai_placeholder_modify: "es. Aggiungi un campo immagine in miniatura con archiviazione, rendi il prezzo obbligatorio...",
    ai_assist: "Assistente AI",
    generating: "Generazione in corso...",

    /** Recently extracted strings for collection editor */
    this_is_subcollection_of: "Questa è una sottocollezione di",
    use_existing_paths_database: "Utilizza i percorsi esistenti nel database",
    describe_collection_ai: "Descrivi la collezione per generarla con l'IA",
    generate_with_ai: "Genera con IA",
    create_from_json_config: "Crea da configurazione JSON",
    paste_json_config: "Incolla la configurazione JSON",
    create_collection_from_file_formats: "Crea collezione da file (CSV, Excel, JSON)",
    select_template: "Seleziona un modello",
    products: "Prodotti",
    collection_products_subtitle: "Gestisci i tuoi prodotti con prezzi, inventario e immagini",
    collection_users_subtitle: "Gestisci gli utenti registrati con i loro profili e ruoli",
    blog_posts: "Articoli del blog",
    collection_blog_posts_subtitle: "Crea e gestisci gli articoli del tuo blog",
    pages: "Pagine",
    collection_pages_subtitle: "Gestisci le pagine statiche del tuo sito",
    continue_from_scratch: "Continua da zero",

    /** Admin views config */
    admin_users: "Utenti del pannello di amministrazione",
    roles_menu: "Ruoli",
    project_settings: "Impostazioni del progetto",

    by_signing_in_you_agree_to_our: "Accedendo accetti i nostri",
    terms_and_conditions: "Termini e Condizioni",
    and_our: "e la nostra",
    privacy_policy: "Informativa sulla privacy",
    email_password: "Email/password",
    sign_in_with_google: "Accedi con Google",

    // --- Auth error messages ---
    auth_user_not_found: "Utente non trovato",
    auth_wrong_password: "Password errata",
    auth_user_disabled: "Account disabilitato",
    auth_account_exists_with_different_credential: "Esiste già un account con questo indirizzo email ma con credenziali diverse",
    auth_email_already_in_use: "Questo indirizzo email è già in uso",
    auth_google_permissions_required: "Sono necessarie le autorizzazioni di Google",
    auth_invalid_email_password: "Email o password non valide",
    auth_enter_email_first: "Inserisci prima l'indirizzo email",
    auth_password_reset_sent: "Email di reimpostazione della password inviata",
    auth_sign_in_account: "Accedi al tuo account",
    auth_create_new_account: "Crea un nuovo account",
    auth_password: "Password",
    auth_reset_password: "Reimposta password",
    auth_new_user: "Nuovo utente",
    auth_have_account: "Hai già un account?",
    auth_sign_in: "Accedi",
    auth_sign_up: "Registrati",


    auto_setup_collections_button: "Configura le collezioni automaticamente",
    auto_setup_collections_title: "Configurazione automatica delle collezioni",
    auto_setup_collections_desc: "Configura le collezioni automaticamente in base ai dati Firestore esistenti. Lascia che Rebase configuri il pannello di amministrazione perfetto per te.",
    this_can_take_a_minute: "Potrebbe richiedere qualche minuto",
    no_collections_found_to_setup: "Nessuna collezione trovata da configurare",
    collections_have_been_setup: "Le collezioni sono state configurate",
    error_setting_up_collections: "Errore durante la configurazione delle collezioni",

    // --- Home Suggestions ---

    admin_panel_ready_bring_data: "Il tuo pannello è pronto. Inizia aggiungendo i tuoi dati.",
    admin_panel_ready_get_started: "Il tuo pannello è pronto. Ecco come iniziare.",
    auto_detect_collections: "Rileva automaticamente le collezioni",
    auto_detect_collections_desc: "Rebase analizzerà i tuoi dati Firestore e configurerà automaticamente le collezioni per te",
    create_a_collection: "Crea una collezione",
    create_collection_desc: "Definisci manualmente la struttura della tua collezione",
    read_the_docs: "Leggi la documentazione",
    read_the_docs_desc: "Scopri come usare Rebase al meglio",
    explore_docs: "Esplora la documentazione",
    want_to_customize_with_code: "Vuoi personalizzare con il codice? Esegui",
    to_scaffold_a_local_project: "per creare un progetto locale",

    // ─── Collection Editor — Validation ──────────────────────────
    validation: "Validazione",
    unique: "Unico",
    required_message: "Messaggio campo obbligatorio",
    required_tooltip: "Non potrai salvare questa entità se questo valore non è impostato",
    unique_tooltip: "Non possono esistere più entità con lo stesso valore",
    lowercase: "Minuscolo",
    uppercase: "Maiuscolo",
    trim: "Rimuovi spazi",
    exact_length: "Lunghezza esatta",
    min_length: "Lunghezza min.",
    max_length: "Lunghezza max.",
    matches_regex: "Corrisponde a regex",
    not_valid_regexp: "Espressione regolare non valida",
    regex_helper: "es. /^\\d+$/ solo per cifre",
    min_value: "Valore min.",
    max_value: "Valore max.",
    less_than: "Minore di",
    more_than: "Maggiore di",
    positive_value: "Valore positivo",
    negative_value: "Valore negativo",
    integer_value: "Valore intero",

    // ─── Collection Editor — Property Edit ───────────────────────
    invalid_regular_expression: "Espressione regolare non valida",
    must_specify_target_collection: "Devi specificare una collezione di destinazione per il campo",
    need_specify_repeat_field: "Devi specificare un campo di ripetizione",
    need_specify_block_properties: "Devi specificare le proprietà di questo blocco",
    incomplete_condition: "Condizione incompleta - seleziona un campo",
    field_name: "Nome del campo",

    // ─── Collection Editor — Display & Config ────────────────────
    kanban_column_property: "Proprietà colonna Kanban",
    select_a_property: "Seleziona una proprietà",
    kanban_property_not_found: "La proprietà \"{{property}}\" non esiste o non è una proprietà string con enum. Seleziona una proprietà valida o cancella la selezione.",
    no_enum_string_properties: "Nessuna proprietà string con enum trovata. Aggiungi una proprietà string con enumValues per usare la vista Kanban.",
    kanban_column_description: "Seleziona una proprietà string con valori enum per raggruppare le entità in colonne",
    create_property: "+ Crea proprietà \"{{property}}\"",
    order_property: "Proprietà di ordinamento",
    order_property_not_found: "La proprietà \"{{property}}\" non esiste o non è una proprietà numerica. Seleziona una proprietà valida o cancella la selezione.",
    no_number_properties: "Nessuna proprietà numerica trovata. Aggiungi una proprietà numerica per abilitare l'ordinamento.",
    order_property_description: "Seleziona una proprietà numerica per mantenere l'ordine degli elementi",
    display_settings: "Impostazioni di visualizzazione",
    default_row_size: "Dimensione riga predefinita",
    side_dialog_width: "Larghezza del dialogo laterale",
    side_dialog_width_description: "Definisci opzionalmente la larghezza (in pixel) del dialogo laterale delle entità. Il valore predefinito è 768px",
    inline_editing_enabled: "I dati possono essere modificati direttamente nella vista tabella",
    inline_editing_disabled: "I dati possono essere modificati solo nella vista modulo",
    inline_editing_description: "Consenti la modifica dei dati direttamente nella vista tabella, senza aprire la vista modulo.",
    include_json_view: "Includi vista JSON",
    no_json_view: "Non includere vista JSON",
    json_view_description: "Includi la rappresentazione JSON del documento.",
    not_found_suffix: "non trovato",

    // ─── Editor ─────────────────────────────────────────────────
    editor_text: "Testo",
    editor_text_description: "Inizia a digitare con testo semplice.",
    editor_heading_1: "Intestazione 1",
    editor_heading_1_description: "Intestazione di sezione grande.",
    editor_heading_2: "Intestazione 2",
    editor_heading_2_description: "Intestazione di sezione media.",
    editor_heading_3: "Intestazione 3",
    editor_heading_3_description: "Intestazione di sezione piccola.",
    editor_todo_list: "Lista di cose da fare",
    editor_todo_list_description: "Tieni traccia delle attività con una lista di cose da fare.",
    editor_bullet_list: "Elenco puntato",
    editor_bullet_list_description: "Crea un semplice elenco puntato.",
    editor_numbered_list: "Elenco numerato",
    editor_numbered_list_description: "Crea un elenco con numerazione.",
    editor_quote: "Citazione",
    editor_quote_description: "Cattura una citazione.",
    editor_code: "Codice",
    editor_code_description: "Cattura un frammento di codice.",
    editor_image: "Immagine",
    editor_image_description: "Carica un'immagine dal tuo computer.",
    editor_multiple: "Multiplo",
    editor_link: "Link",
    editor_save: "Salva",
    editor_cancel: "Annulla",
    editor_remove_link: "Rimuovi link",
    editor_paste_or_type_link: "Incolla o digita il link",
    editor_open_in_new_window: "Apri in una nuova finestra",
    editor_bold: "Grassetto",
    editor_italic: "Corsivo",
    editor_underline: "Sottolineato",
    editor_strikethrough: "Barrato",
    editor_autocomplete: "Completamento automatico",
    editor_autocomplete_description: "Aggiungi testo basato sul contesto.",

    // ─── Text Search Dialog ─────────────────────────────────────
    text_search_dialog_title: "Abilita ricerca testuale",
    text_search_local_not_recommended: "La ricerca testuale locale non è consigliata per collezioni di grandi dimensioni.",
    text_search_local_fetch_warning: "Tieni presente che abilitando la ricerca testuale locale sarà necessario scaricare tutti i documenti dalla collezione e memorizzarli nel browser. Questo può essere inefficiente per collezioni grandi e può comportare costi aggiuntivi.",
    text_search_external_suggestion: "Per collezioni più grandi, ti consigliamo di utilizzare un motore di ricerca esterno come Algolia o Elastic Search e di assegnare un delegato di ricerca alla tua configurazione.",
    text_search_local_description: "La ricerca testuale locale è il modo più semplice per abilitare la ricerca testuale nella tua collezione. Carica tutti i documenti della collezione nel browser ed esegue la ricerca localmente. È l'opzione consigliata per le collezioni piccole.",
    text_search_own_implementation: "Hai implementato il tuo controller di ricerca testuale. Puoi abilitare la ricerca testuale per la tua collezione.",
    text_search_enable_for_collection: "Abilita per questa collezione",
    text_search_enable_for_project: "Abilita per il progetto",
    text_search_enabled_snackbar: "Ricerca testuale locale abilitata",

    settings_heading: "Impostazioni",
    settings_project_name: "Nome del progetto",
    settings_default_language: "Lingua predefinita",
    settings_default_language_caption: "Seleziona la lingua di base per questo progetto. Gli utenti possono modificare questa preferenza nelle impostazioni personali.",
    settings_enable_local_text_search: "Abilita la ricerca testuale locale",
    settings_local_text_search_caption: "Abilita la ricerca testuale locale per tutte le collezioni. Questo ti permetterà di cercare campi di testo nelle collezioni utilizzando la barra di ricerca di Rebase. Tieni presente che questa funzionalità può comportare un numero maggiore di letture, poiché verranno indicizzati tutti i campi di testo delle tue collezioni.",
    settings_doc_history_all_collections: "Cronologia documenti abilitata per tutte le collezioni",
    settings_doc_history_caption: "Quando attivato, tutte le collezioni avranno la cronologia abilitata per impostazione predefinita. Puoi modificare questa impostazione per ogni singola collezione. La cronologia verrà salvata nella sottocollezione __history di ogni documento.",
    settings_theme: "Tema",
    settings_primary_color: "Colore primario",
    settings_secondary_color: "Colore secondario",
    settings_sample_theme_components: "Componenti di esempio del tema",
    settings_drag_drop_logo: "Trascina e rilascia il tuo logo qui",
    settings_security_rules: "Regole di sicurezza",
    settings_security_rules_description: "Rebase utilizza le regole di sicurezza di Firebase per limitare l'accesso ai dati. Quando si crea un nuovo utente tramite Rebase, l'attributo personalizzato rebaseUser viene aggiunto all'utente nel progetto client. Aggiungendo le seguenti regole di sicurezza al tuo progetto, ti assicuri che gli utenti Rebase possano accedere ai dati tramite Rebase.",
    settings_security_rules_add_domain: "Ricorda di aggiungere il dominio {{domain}} ai domini consentiti del tuo provider",
    settings_security_rules_caption: "Queste regole limitano l'accesso ai dati solo agli utenti Rebase, ma non applicano i permessi a livello di database. I permessi vengono applicati nel frontend, il che funziona bene per la maggior parte dei progetti. Se hai bisogno di applicare i permessi a livello di database, puoi modificare queste regole di sicurezza. I ruoli assegnati a un utente vengono impostati come attributi personalizzati nel token di autenticazione Firebase, quindi puoi utilizzarli nelle tue regole di sicurezza.",

    // ─── Studio: SQL Editor ─────────────────────────────────────
    studio_sql_executing_query: "ESECUZIONE DELLA QUERY...",
    studio_sql_query_error: "Errore nella query",
    studio_sql_run_query_placeholder: "Esegui una query per vedere i risultati",
    studio_sql_visual_execution_plan: "Piano di esecuzione visuale",
    studio_sql_success: "SUCCESS",
    studio_sql_no_results: "La query è stata eseguita correttamente ma non ha restituito risultati.",
    studio_sql_rows: "Rows:",
    studio_sql_time: "Time:",
    studio_sql_copy_markdown: "Copia come Markdown",
    studio_sql_export_json: "Esporta JSON",
    studio_sql_export_csv: "Esporta CSV",
    studio_sql_format_sql: "Formatta SQL",
    studio_sql_explain: "Explain",
    studio_sql_limit_1000: "Limit 1000",
    studio_sql_remove_from_favorites: "Rimuovi dai preferiti",
    studio_sql_add_to_favorites: "Aggiungi ai preferiti",
    studio_sql_save: "Save",
    studio_sql_run: "Run",
    studio_sql_database: "Database",
    studio_sql_role: "Role",
    studio_sql_admin: "(Admin)",
    studio_sql_select_db: "Scegli il database",
    studio_sql_query_results: "Risultati della query",
    studio_sql_save_snippet: "Salva frammento SQL",
    studio_sql_snippet_name: "Nome del frammento",
    studio_sql_snippet_name_placeholder: "es. Ottieni tutti gli utenti",
    studio_sql_snippet_saved_local: "Verrà salvato nella memoria locale del browser.",
    studio_sql_cancel: "Cancel",
    studio_sql_dangerous_operation: "Rilevata un'operazione pericolosa",
    studio_sql_dangerous_operation_body: "La query che stai per eseguire contiene operazioni potenzialmente distruttive (DELETE, DROP, TRUNCATE o UPDATE senza WHERE). Vuoi davvero continuare?",
    studio_sql_snippet_saved: "Frammento «{{name}}» salvato.",
    studio_sql_markdown_copied: "Risultati copiati come Markdown!",
    studio_sql_markdown_copy_failed: "Impossibile copiare il Markdown negli appunti.",
    studio_sql_row_updated: "Riga aggiornata con successo.",
    studio_sql_cannot_edit_missing_query: "Impossibile modificare le righe: manca la query sottostante.",
    studio_sql_cannot_resolve_table: "Impossibile determinare la tabella o la chiave primaria",
    studio_sql_missing_pk: "Alla riga mancano le colonne della chiave primaria: {{columns}}. Impossibile aggiornarla in sicurezza.",
    studio_sql_update_failed: "Aggiornamento non riuscito: {{message}}",
    studio_sql_execution_not_supported: "L'origine dati attuale non supporta l'esecuzione di SQL.",
    studio_sql_error_executing: "Si è verificato un errore durante l'esecuzione della query.",
    studio_sql_error_explaining: "Si è verificato un errore durante l'analisi della query.",
    studio_sql_save_first_to_favorite: "Salva il frammento prima di aggiungerlo ai preferiti.",
    studio_sql_collections_label: "Collections:",
    studio_sql_admin_collections_tooltip: "Tables in this query that are mapped as admin collections",
    studio_sql_edit_entity: "Edit {{name}} #{{id}}",
    studio_sql_sql_not_supported: "Questa origine dati non supporta l'esecuzione di SQL",
    studio_sql_fetch_error: "Impossibile recuperare le opzioni di connessione: {{message}}",
    studio_sql_unexpected_format: "Formato dei dati inatteso: {{type}}",
    studio_sql_no_tables: "Nessuna tabella trovata in questo database.",
    studio_sql_schema_fetch_error: "Impossibile recuperare lo schema: {{message}}",

    // ─── Studio: SQL Editor Sidebar ──────────────────────────────
    studio_sql_sidebar_snippets: "Snippets",
    studio_sql_sidebar_history: "History",
    studio_sql_sidebar_schema: "Schema",
    studio_sql_sidebar_no_snippets: "Nessun frammento salvato",
    studio_sql_sidebar_save_snippet_hint: "Salva una query per ritrovarla qui.",
    studio_sql_sidebar_no_history: "Nessuna cronologia",
    studio_sql_sidebar_history_hint: "Le query eseguite appariranno qui.",
    studio_sql_sidebar_delete_snippet: "Elimina frammento",
    studio_sql_close_tab: "Chiudi questa scheda di query",
    studio_sql_new_tab: "Nuova scheda di query",

    // ─── Studio: Schema Browser ──────────────────────────────────
    studio_schema_tables: "Tables",
    studio_schema_loading: "Caricamento dello schema...",
    studio_schema_no_tables: "Nessuna tabella trovata",
    studio_schema_retry: "Retry",
    studio_schema_primary_key: "Chiave primaria",
    studio_schema_select_all: "SELECT * FROM",
    studio_schema_insert_into: "INSERT INTO",
    studio_schema_update: "UPDATE",
    studio_schema_delete_from: "DELETE FROM",
    studio_schema_columns: "{{count}} colonne",

    // ─── Studio: RLS Editor ──────────────────────────────────────
    studio_rls_title: "Sicurezza a livello di riga",
    studio_rls_description: "Gestisci i criteri RLS delle tue tabelle",
    studio_rls_enabled: "RLS attiva",
    studio_rls_disabled: "RLS disattivata",
    studio_rls_no_rls: "Senza RLS",
    studio_rls_enable_rls: "Attiva RLS",
    studio_rls_disable_rls: "Disattiva RLS",
    studio_rls_create_policy: "Crea criterio",
    studio_rls_policies: "Policies",
    studio_rls_no_policies: "Nessun criterio definito",
    studio_rls_no_policies_desc: "Questa tabella non ha criteri RLS. L'accesso a tutte le righe dipende dallo stato della RLS.",
    studio_rls_add_first_policy: "Aggiungi il tuo primo criterio",
    studio_rls_force_rls: "Forza RLS",
    studio_rls_force_rls_desc: "Se attivo, i criteri RLS si applicano anche al proprietario della tabella.",
    studio_rls_enable_force_rls: "Attiva RLS forzata",
    studio_rls_disable_force_rls: "Disattiva RLS forzata",
    studio_rls_edit: "Edit",
    studio_rls_delete: "Delete",
    studio_rls_confirm_delete_title: "Elimina criterio",
    studio_rls_confirm_delete_body: "Vuoi davvero eliminare questo criterio? L'operazione non può essere annullata.",
    studio_rls_confirm_enable_title: "Attiva la sicurezza a livello di riga",
    studio_rls_confirm_enable_body: "Attivando la RLS l'accesso alle righe di questa tabella sarà limitato dai tuoi criteri. Assicurati di avere criteri adeguati.",
    studio_rls_confirm_disable_title: "Disattiva la sicurezza a livello di riga",
    studio_rls_confirm_disable_body: "Disattivando la RLS tutte le righe saranno accessibili a tutti i ruoli. Vuoi davvero continuare?",
    studio_rls_select_table: "Seleziona una tabella",
    studio_rls_no_tables: "Nessuna tabella disponibile",
    studio_rls_error: "Errore nel caricamento dei criteri",
    studio_rls_retry: "Retry",
    studio_rls_loading: "Caricamento dei criteri...",

    // ─── Studio: Policy Editor ───────────────────────────────────
    studio_policy_edit: "Modifica criterio",
    studio_policy_create: "Crea un nuovo criterio",
    studio_policy_defining_rules: "Definizione delle regole di accesso per",
    studio_policy_cancel: "Cancel",
    studio_policy_save: "Salva criterio",
    studio_policy_template: "Parti da un modello (facoltativo)",
    studio_policy_select_template: "Seleziona un modello...",
    studio_policy_name: "Nome del criterio",
    studio_policy_name_placeholder: "Assegna al criterio un nome descrittivo",
    studio_policy_behavior: "Comportamento del criterio",
    studio_policy_permissive: "Permissive",
    studio_policy_permissive_desc: "Combinata con «OR»",
    studio_policy_restrictive: "Restrictive",
    studio_policy_restrictive_desc: "Combinata con «AND»",
    studio_policy_command: "Comando del criterio",
    studio_policy_target_roles: "Ruoli destinatari",
    studio_policy_roles_placeholder: "Seleziona i ruoli (predefinito: public)",
    studio_policy_using_expr: "Espressione USING",
    studio_policy_using_expr_desc: "Si applica alle righe esistenti (SELECT, UPDATE, DELETE)",
    studio_policy_check_expr: "Espressione WITH CHECK",
    studio_policy_check_expr_desc: "Si applica alle righe nuove o modificate (INSERT, UPDATE)",
    studio_policy_help_title: "Guida alla sicurezza a livello di riga (RLS)",
    studio_policy_help_intro: "La sicurezza a livello di riga (RLS) consente di limitare le righe che un utente può leggere o modificare in base al suo stato di autenticazione o ai suoi ruoli.",
    studio_policy_help_step1_title: "1. Seleziona un modello",
    studio_policy_help_step1_desc: "Se non hai mai usato la RLS, il modo più semplice è partire da un modello predefinito nell'elenco. Configurerà automaticamente il criterio per casi comuni come «gli utenti possono aggiornare le proprie righe».",
    studio_policy_help_step2_title: "2. Ruoli destinatari",
    studio_policy_help_step2_desc: "Scegli a quali utenti si applica il criterio:",
    studio_policy_help_role_public: "Si applica a tutti (autenticati o meno).",
    studio_policy_help_role_authenticated: "Si applica solo agli utenti autenticati.",
    studio_policy_help_role_anon: "Si applica solo agli utenti NON autenticati.",
    studio_policy_help_step3_title: "3. Espressione USING",
    studio_policy_help_step3_desc: "Una condizione SQL che deve risultare vera perché le righe esistenti siano visibili o modificabili (SELECT, UPDATE, DELETE).",
    studio_policy_help_step3_example: "Garantisce che gli utenti vedano solo le righe di cui sono proprietari.",
    studio_policy_help_step4_title: "4. Espressione WITH CHECK",
    studio_policy_help_step4_desc: "Una condizione SQL che deve risultare vera perché le righe nuove o modificate vengano salvate (INSERT, UPDATE).",
    studio_policy_help_step4_example: "Di solito coincide con l'espressione USING quando gli utenti possono inserire o modificare solo i propri dati.",
    studio_policy_help_auth_vars_title: "Variabili di autenticazione di Rebase",
    studio_policy_help_auth_vars_desc: "Rebase mette a disposizione funzioni native che puoi usare nelle tue espressioni:",
    studio_policy_help_auth_uid: "Restituisce l'ID dell'utente corrente come testo. Esempio:",
    studio_policy_help_auth_jwt: "Restituisce l'intero payload del JWT come JSONB, così puoi verificare claim personalizzati. Esempio:",
    studio_policy_help_auth_roles: "Restituisce gli ID dei ruoli dell'utente come stringa separata da virgole. Da usare preferibilmente con:",
    studio_policy_help_docs_cta: "Per saperne di più sui criteri di Postgres, consulta la documentazione ufficiale.",
    studio_policy_help_read_docs: "Leggi la documentazione",
    studio_policy_help_got_it: "Ho capito!",

    // ─── Studio: UI Actions ──────────────────────────────────────
    studio_add_kanban_column: "Aggiungi colonna",
    studio_add_kanban_column_title: "Aggiungi colonna Kanban",
    studio_add_kanban_column_name: "Nome della colonna",
    studio_add_kanban_column_name_placeholder: "Nome della nuova colonna",
    studio_add_kanban_column_add: "Add",
    studio_add_kanban_column_cancel: "Cancel",
    studio_collection_view_sql: "Editor SQL",
    studio_collection_view_admin: "Vista di amministrazione",
    studio_editor_collection_tooltip: "Modifica lo schema della collezione",
    studio_editor_collection_no_permission: "Non hai il permesso di modificare questa collezione",
    studio_editor_collection_start_tooltip: "Copia il percorso o modifica lo schema",
    studio_editor_collection_start_no_permission: "Non hai il permesso di modificare questa collezione",
    studio_editor_collection_start_copied: "Copied!",
    studio_editor_entity_tooltip: "Modifica lo schema dell'entità",
    studio_editor_entity_no_permission: "Non hai il permesso di modificare questa entità",
    studio_home_edit_collection: "Modifica collezione",
    studio_home_delete_collection: "Elimina collezione",
    studio_home_confirm_delete_title: "Eliminare la collezione?",
    studio_home_confirm_delete_body: "Vuoi davvero eliminare la collezione «{{name}}»? L'operazione non può essere annullata.",
    studio_kanban_setup: "Configurazione Kanban",
    studio_missing_reference: "Riferimento mancante: {{path}}",
    studio_missing_reference_create: "Create",
    studio_new_collection: "Nuova collezione",
    studio_new_collection_card: "Nuova collezione",
    studio_new_collection_no_permission: "Non hai i permessi per creare collezioni",
    studio_property_add_column: "Aggiungi una nuova proprietà",
    studio_property_add_column_no_permission: "Non hai il permesso di aggiungere nuove proprietà",
    studio_add_kanban_column_desc: "Aggiunge una nuova opzione alla proprietà «{{property}}». Verrà creata una nuova colonna nella board Kanban.",
    studio_add_kanban_column_adding: "Adding...",
    studio_collection_view_edit: "Edit",
    studio_editor_collection_disabled: "La modifica delle collezioni è disattivata",
    studio_editor_collection_edit: "Modifica collezione",
    studio_editor_entity_save_first: "Devi salvare il documento prima di modificare lo schema",
    studio_editor_entity_edit_schema: "Modifica lo schema di questo modulo",
    studio_editor_collection_start_save_filter: "Salva filtro e ordinamento predefiniti",
    studio_editor_collection_start_clear_filter: "Cancella filtro e ordinamento predefiniti",
    studio_editor_collection_start_reset_filter: "Ripristina filtro e ordinamento predefiniti",
    studio_editor_collection_start_saved: "Configurazione predefinita salvata",
    studio_home_duplicate_collection: "Duplicate",
    studio_home_delete: "Delete",
    studio_home_confirm_delete_no_data: "Non verrà eliminato alcun dato, solo la collezione nel pannello di amministrazione",
    studio_home_collection_deleted: "Collezione eliminata",
    studio_kanban_configure: "Configura Kanban",
    studio_missing_reference_error: "Nessuna collezione per il percorso: {{path}}",
    studio_new_collection_add: "Aggiungi nuova collezione",

    // ─── Property field labels ──────────────────────────────────
    db_column_type: "Tipo di colonna del database",
    primary_key_unique_id: "Chiave primaria / ID univoco",
    spread_children_as_columns: "Espandi i figli come colonne",
    mode: "Modalità",
    timezone: "Fuso orario",
    target_collection: "Collezione di destinazione",

    // ─── Storage property ───────────────────────────────────────
    storage_file_name: "Nome del file",
    storage_path: "Percorso di archiviazione",
    storage_max_size: "Dimensione massima (in byte)",
    storage_resize_mode: "Modalità di ridimensionamento",
    storage_output_format: "Formato di output",
    storage_max_width: "Larghezza massima (px)",
    storage_max_height: "Altezza massima (px)",
    storage_quality: "Qualità (0-100)",
    storage_file_upload_config: "Configurazione caricamento file",
    storage_image_resize_config: "Configurazione ridimensionamento immagine",
    storage_all_file_types: "Tutti i tipi di file consentiti",
    storage_allowed_file_types: "Tipi di file consentiti",
    storage_include_bucket_url: "Includi URL del bucket (s3://...) nel valore salvato",
    storage_save_url: "Salva URL invece del percorso di archiviazione",

    // ─── DateTime property ──────────────────────────────────────
    datetime_automatic_value: "Valore automatico",

    // ─── Markdown property ──────────────────────────────────────
    markdown_paste_behavior: "Comportamento incolla",

    // ─── Entity identity bar and inspector ──────────────────────
    entity_saved: "Salvato",
    more_actions: "Altre azioni",
    record_history: "Cronologia",
    inspect_record: "Ispeziona record",
    inspect: "Ispeziona",
    close_inspector: "Chiudi l'ispettore",
    open_in_live_site: "Apri nel sito pubblicato",

    // ─── Revision history ───────────────────────────────────────
    history_revert: "Torna a questa versione",
    history_revert_title: "Ripristinare i dati a questa versione?",
    history_reverted: "Ripristinata la versione selezionata",
    history_revert_error: "Errore durante il ripristino del record",
    history_revert_dirty: "Salva o annulla le modifiche prima di ripristinare",
    history_empty: "Nessuna cronologia disponibile",
    history_empty_description: "Quando salvi un record viene creata una nuova versione e conservata nella cronologia.",
    history_new_entity: "La cronologia è disponibile solo per i record esistenti",
    history_no_more: "Nessun'altra cronologia",

    // ─── Studio: tools, groups and empty states ─────────────────
    // The admin's own three groups, read by `useNavigationGroupLabel` the same
    // way as the Studio ones below — the group *name* is an identifier the
    // ordering and the icons key off, and only the heading is translated.
    studio_group_views: "Viste",
    studio_group_admin: "Amministrazione",
    studio_group_settings: "Impostazioni",
    studio_group_database: "Database",
    studio_group_compute: "Elaborazione",
    studio_group_storage: "Archiviazione",
    studio_group_api: "API",
    studio_group_access_control: "Controllo accessi",
    studio_tool_sql: "Console SQL",
    studio_tool_sql_description: "Esegui query SQL",
    studio_tool_js: "Console JS",
    studio_tool_js_description: "Esegui JavaScript",
    studio_tool_rls: "Criteri RLS",
    studio_tool_rls_description: "Sicurezza a livello di riga",
    studio_tool_storage: "Archiviazione",
    studio_tool_storage_description: "Gestisci i file di archiviazione",
    studio_tool_cron: "Processi cron",
    studio_tool_cron_description: "Gestisci le attività pianificate",
    studio_tool_schema_visualizer: "Visualizzatore di schema",
    studio_tool_schema_visualizer_description: "Diagramma ER interattivo del database",
    studio_tool_branches: "Rami",
    studio_tool_branches_description: "Crea e gestisci i rami del database",
    studio_tool_backups: "Backup",
    studio_tool_backups_description: "Scarica i backup del database",
    studio_tool_api: "Esploratore API",
    studio_tool_api_description: "Documentazione API interattiva e test",
    studio_tool_logs: "Esploratore dei log",
    studio_tool_logs_description: "Log di sistema e delle query in tempo reale",
    studio_tool_api_keys: "Chiavi API",
    studio_tool_api_keys_description: "Crea e gestisci chiavi API con ambito",
    studio_backups_denied_title: "Non puoi elencare i backup di questo progetto",
    studio_backups_denied_hint: "Il progetto non ha nulla che non va. Elencare i backup richiede una connessione da amministratore, e l'account connesso è stato rifiutato.",
    studio_backups_read_failed: "Non è stato possibile leggere i backup di questo progetto",
    studio_backups_downloading: "Download in corso…",
    studio_backups_roles_file: "File dei ruoli",
    studio_backups_roles_file_hint: "Il .globals.sql salvato con questo backup. Ricrea i ruoli del database a cui fanno riferimento i permessi e la sicurezza a livello di riga del dump, e `rebase db restore` lo legge accanto al .dump, quindi tieni insieme i due file.",
    studio_backups_no_roles_file: "Nessun file dei ruoli",
    studio_backups_no_roles_file_hint: "Con questo backup non è stato salvato nessun .globals.sql. Ripristinarlo in un nuovo Postgres si ferma al primo permesso concesso a un ruolo del database che lì non esiste.",
    studio_cron_denied_title: "Non puoi elencare i processi cron di questo progetto",
    studio_cron_denied_hint: "Il progetto non ha nulla che non va. L'API cron è riservata agli amministratori, e l'account connesso è stato rifiutato.",
    studio_cron_read_failed: "Non è stato possibile leggere i processi cron di questo progetto",
    studio_api_keys_denied_title: "Non puoi elencare le chiavi API di questo progetto",
    studio_api_keys_denied_hint: "Il progetto non ha nulla che non va. Gestire le chiavi API è un'operazione da amministratore, e l'account connesso è stato rifiutato.",
    studio_api_keys_read_failed: "Non è stato possibile leggere le chiavi API di questo progetto",
    studio_api_keys_empty_title: "Ancora nessuna chiave API",
    studio_api_keys_empty_hint: "Crea una chiave per abilitare l'autenticazione tra servizi",
    studio_api_keys_revoke: "Revoca",
    studio_api_keys_select_hint: "Seleziona una chiave API per vederne i dettagli",
    studio_api_keys_permissions: "Permessi",
    studio_api_keys_no_permissions: "Nessun permesso configurato",
    studio_api_keys_revoke_confirmation: "Conferma della revoca",
    studio_api_keys_name_label: "Nome:",
    studio_api_keys_access_label: "Accesso:",
    studio_api_keys_admin_granted: "Ruolo di amministratore concesso",
    studio_api_keys_admin_granted_hint: "le route di amministrazione e le policy default_admin",
    studio_api_keys_done: "Fatto",
    studio_api_keys_status_active: "Attiva",
    studio_api_keys_status_expired: "Scaduta",
    studio_api_keys_status_revoked: "Revocata",
    studio_api_keys_stat_status: "Stato",
    studio_api_keys_stat_last_used: "Ultimo utilizzo",
    studio_api_keys_stat_expires: "Scade",
    studio_api_keys_never: "Mai",
    studio_api_keys_role_service: "Servizio",
    studio_api_keys_stat_rate_limit: "Limite di richieste",
    studio_api_keys_rate_limit_default: "Predefinito (1000/15 min)",
    studio_api_keys_stat_created_by: "Creata da",
    studio_api_keys_copy_failed: "Copia non riuscita",
    studio_branches_denied_title: "Non puoi elencare i rami di questo progetto",
    studio_branches_denied_hint: "Il progetto non ha nulla che non va. I rami passano dalla connessione da amministratore, e l'account connesso è stato rifiutato.",
    studio_branches_read_failed: "Non è stato possibile leggere i rami di questo progetto",
    studio_schema_no_collections: "Nessuna collection dichiarata",
    studio_schema_no_collections_body: "Non c'è ancora nulla da disegnare. Aggiungi una collection in config/collections/, oppure apri «Modifica collection» per aggiungerne una qui.",
    studio_schema_introspect_hint: "Su un database che ha già delle tabelle, rebase schema introspect scrive i file di collection al posto tuo.",


    // ─── Studio: RLS editor confirmations ───────────────────────
    studio_rls_enable_confirm_title: "Attivare la sicurezza a livello di riga?",
    studio_rls_enable_confirm_body: "Finché un criterio non lo consente, nessuna riga di {{table}} è leggibile. Postgres nega per impostazione predefinita.",
    studio_rls_disable_confirm_title: "Disattivare la sicurezza a livello di riga?",
    studio_rls_disable_confirm_body: "Tutti i criteri su {{table}} smettono di essere applicati. Chi raggiunge la tabella può leggere e scrivere ogni riga.",
    studio_rls_drop_policy_title: "Eliminare questo criterio?",
    studio_rls_drop_policy_body: "{{policy}} viene rimosso da {{table}} nel database. Nel codice non viene scritto nulla, quindi un deploy può ripristinarlo.",
    studio_rls_unapplied: "Non applicato",
    studio_rls_unapplied_tooltip: "Dichiarato nel codice, non ancora nel database. Salvalo qui per pianificare e applicare la modifica, oppure esegui `rebase db push`.",


    // ─── Studio: empty states that name a remedy ────────────────
    studio_branches_unavailable_title: "Il branching del database non è disponibile",
    studio_branches_unavailable_body: "Il branching richiede un backend Postgres con una connessione da amministratore. Imposta ADMIN_CONNECTION_STRING nell'ambiente del backend.",
    studio_backups_not_configured_title: "I backup non sono configurati",
    studio_backups_not_configured_body: "Imposta BACKUP_DESTINATION su un percorso locale o su un URL s3:// o gs://, poi crea un backup con `rebase db backup` o un cron pianificato.",
    studio_cron_empty_title: "Nessun processo cron registrato",
    studio_cron_empty_body: "Aggiungi un file in backend/crons/ che esporti di default una CronJobDefinition.",
    studio_read_the_docs: "Leggi la documentazione"
};
